const features = [
  {
    icon: "ri-file-text-line",
    label: "小说全文",
    desc: "从第 1 章到第 326 章按序排布，段落排版重新校对，长篇阅读不跳行。",
  },
  {
    icon: "ri-scissors-cut-line",
    label: "未删减版",
    desc: "保留完整情节与人物交代，补回早期章节被略去的细节段落。",
  },
  {
    icon: "ri-headphone-line",
    label: "有声书",
    desc: "42 集完整演播，与文字章节对应，支持碎片时间连续收听。",
  },
  {
    icon: "ri-stack-line",
    label: "故事合集",
    desc: "书信、日常、回忆等主题短篇各自独立，也能与主线彼此呼应。",
  },
];

export default function ResourceSection() {
  return (
    <section className="w-full border-b border-background-200 bg-accent-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:gap-14">
          <div className="lg:w-[36%]">
            <span className="flex items-center gap-2 text-xs font-label tracking-wide text-accent-800">
              <i className="ri-database-2-line" />
              资源总览
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-[28px]">
              一个页面收齐全部阅读形态
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              无论是想通读小说全文，还是只想找未删减版补齐情节，或换一种方式用耳朵听，都能在这里直接开始。
            </p>
          </div>

          <div className="grid flex-1 grid-cols-1 gap-4 sm:grid-cols-2">
            {features.map((f) => (
              <div
                key={f.label}
                className="rounded-lg border border-accent-200 bg-background-50 p-4 md:p-5"
              >
                <div className="flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                    <i className={`${f.icon} text-lg`} />
                  </span>
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    {f.label}
                  </h3>
                </div>
                <p className="mt-3 text-sm leading-6 text-foreground-600">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}